import { classes, style } from 'typestyle';
import { smallFont, TEAL_PRIMARY } from 'src/utils/Style/Theme';
import { asyncCellStateNest } from 'src/components/ConfigurableGrid/ConfigurableGrid.styles';
import styles from 'src/pages/AssortmentBuild/StyleEdit/DividedColumnDetailsSection/DividedColumnDetails.styles';

const HISTORY_STYLE_SECTION_MARGIN_TOP = 30;
const STYLE_PANE_IMG_WIDTH = 100;
const STYLE_PANE_IMG_HEIGHT = 150;

const historyStylePane = style({
  $debugName: 'historyStylePane',
  paddingLeft: 18,
  paddingRight: 18,
  paddingBottom: 40,
  paddingTop: 10,
  fontSize: smallFont,
  fontWeight: 400,
  $nest: {
    // enables the `.loading` / `.redecorating` spinner classes on busy cells
    ...asyncCellStateNest,
  },
});
const historyStylePaneTitle = style({
  $debugName: 'historyStylePaneTitle',
  color: TEAL_PRIMARY,
  fontWeight: 'bold',
  fontSize: '20px',
  paddingTop: 15,
});
const historyStylePaneDescription = style({
  $debugName: 'historyStylePaneDescription',
  fontWeight: 'bold',
  fontSize: '18px',
});
const historyStylePaneSwatches = style({
  $debugName: 'historyStylePaneSwatches',
  display: 'flex',
  marginTop: 15,
  $nest: {
    div: {
      border: '1px solid #aca899',
      cursor: 'pointer',
      width: 20,
      height: 20,
      margin: '5px 3px',
      flexShrink: 0,
    },
  },
});

const historyStylePanePinnedSwatchesMargin = style({
  $debugName: 'historyStylePanePinnedSwatchesMargin',
  marginTop: 10,
  marginBottom: 10,
});

export const containerChildBase = () =>
  style({
    $debugName: 'containerChildBase',
    display: 'flex',
    borderTop: '1px solid #eee',
    borderLeft: '1px solid #eee',
    borderRight: '1px solid #eee',
    padding: 5,
    flexWrap: 'wrap',
  });

const historyStylePaneGroup = style({
  $debugName: 'historyStylePaneGroup',
  marginTop: HISTORY_STYLE_SECTION_MARGIN_TOP,
});

const historyStylePaneGroupContent = style({
  $debugName: 'historyStylePaneGroupContent',
  borderBottom: '1px solid #eee',
});

const historyStylePaneGroupTitleContainer = style({
  $debugName: 'historyStylePaneGroupTitleContainer',
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: 5,
  cursor: 'pointer',
});

const historyStylePaneGroupTitle = style({
  $debugName: 'historyStylePaneGroupTitle',
  alignSelf: 'flex-start',
  fontSize: '1rem',
  fontWeight: 600,
});

const historyStylePaneGroupToggle = style({
  $debugName: 'historyStylePaneGroupToggle',
  alignSelf: 'flex-end',
});

const historyStylePaneTuple = style({
  $debugName: 'historyStylePaneTuple',
  display: 'flex',
});

const historyStylePaneLabel = classes(
  style({
    $debugName: 'historyStylePaneLabel',
    width: '40%',
    backgroundColor: '#f9f9f9',
  }),
  containerChildBase(),
);

const historyStylePaneLabelText = style({
  $debugName: 'historyStylePaneLabelText',
  alignSelf: 'center',
});

const historyStylePaneSwatchContainer = style({
  overflowX: 'auto',
});

const historyStylePaneSkeletonImage = style({
  display: 'flex',
  justifyContent: 'center',
  padding: '10px 0',
});

const historyStylePaneSkeletonSwatches = style({
  display: 'flex',
  gap: 6,
  padding: '15px 5px',
});

const historyStylePaneNoData = style({
  color: '#666',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 240,
  textAlign: 'center',
});

const historyStylePaneNoDataTitle = style({
  color: '#444',
  fontSize: '1rem',
  fontWeight: 600,
  marginBottom: 4,
});

const historyStylePaneValue = classes(
  style({
    $debugName: 'historyStylePaneValue',
    width: '60%',
    overflowWrap: 'anywhere',
    $nest: {
      [`& .${styles.fakeDropdown}`]: {
        marginBottom: 0,
      },
      // this specific style goes in a lot of directions
      // it's imported from the `DividedColumnDetails` styles, where it's
      // used to pass into `InputGeneric`, then we're using it to
      // override a style via it's exported classname here
      [`& .${styles.dataTextInput}`]: {
        marginBottom: 0,
        padding: 0,
        height: '18px', // kinda small but the element has a lot of padding, might be changed after review
        fontSize: 'inherit',
      },
      // `input-generic` has a `marginBottom` in the div above `dataTextInput`
      // that isn't easily selectable.  This selector gets the parent of `dataTextInput` for removing it
      [`& div:has(> .${styles.dataTextInput})`]: {
        marginBottom: 0,
      },
      [`& .form-control)`]: {
        fontSize: 'inherit',
      },
      [`& .${styles.dataItem}`]: {
        height: '32px', // override to be shorter than DVCD items
      },
    },
  }),
  containerChildBase(),
);

export default {
  historyStylePaneSwatchContainer,
  historyStylePaneSkeletonImage,
  historyStylePaneSkeletonSwatches,
  historyStylePaneNoData,
  historyStylePaneNoDataTitle,
  historyStylePane,
  historyStylePaneTitle,
  historyStylePaneDescription,
  historyStylePaneSwatches,
  historyStylePanePinnedSwatchesMargin,
  historyStylePaneGroup,
  historyStylePaneGroupContent,
  historyStylePaneGroupTitleContainer,
  historyStylePaneGroupTitle,
  historyStylePaneGroupToggle,
  historyStylePaneTuple,
  historyStylePaneLabel,
  historyStylePaneLabelText,
  historyStylePaneValue,
  STYLE_PANE_IMG_WIDTH,
  STYLE_PANE_IMG_HEIGHT,
};
